import { createSlice } from '@reduxjs/toolkit'

import { getPracticeOverview } from './dashboardThunk'

const initialState = {
  isloading: false,
  isError: false,
  errorMsg: null,
  // unused
  activeFacility: null,
  patients: {
    totalPatientCount: 0,
    prevTotalCount: 0,
    comparisonPercentage: 0,
  },
  procedure_modifiers: [],
  encounters: {
    totalencountersCount: 0,
    prevTotalCount: 0,
    comparisonPercentage: 0,
  },
  revenue: {
    totalrevenueCount: 0,
    prevTotalCount: 0,
    comparisonPercentage: 0,
  },
  rvu: {
    totalrvuCount: 0,
    prevTotalCount: 0,
    comparisonPercentage: 0,
  },
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setProcedureModifiers: (state, action) => {
      state.procedure_modifiers = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPracticeOverview.pending, (state, action) => {
        state.isloading = true
      })
      .addCase(getPracticeOverview.fulfilled, (state, action) => {
        return { ...state, ...action?.payload, isloading: false }
      })
      .addCase(getPracticeOverview.rejected, (state, action) => {
        state.isloading = false
        state.isError = true
        if (action.payload) {
          state.errorMsg = action.payload
        } else {
          state.errorMsg = action.error.message?.toString()
        }
      })
  },
})

export const { setProcedureModifiers } = dashboardSlice.actions
export default dashboardSlice.reducer
